import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {EmailDashboardOverdueComponent} from './email-dashboard-overdue/email-dashboard-overdue.component';



export const emailDashboardOverdueroutes: Routes = [
  {
    path: 'email-dashboard-overdue',
    component: EmailDashboardOverdueComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(emailDashboardOverdueroutes)],
  exports: [RouterModule]
})
export class EmailDashboardOverdueRoutingModule { }



// WEBPACK FOOTER //
// /opt/app/src/app/features/email-dashboard-overdue/email-dashboard-overdue-routing.module.ts